import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICellForm, NotebookCellResource } from '@mode/notebooks/contract';
import { Observable } from 'rxjs';
import { NotebookVisualizationResource } from '@mode/notebooks/contract';

@Injectable({ providedIn: 'root' })
export class NotebookCellClientService {
  constructor(private http: HttpClient) {}

  public addCell(CellForm: ICellForm) {
    const { accountToken, reportToken, notebookToken, payload } = CellForm;
    const queryParams = new HttpParams().set('embed[new_python_cell_run]', '1');
    const body: any = { python_cell: { content: payload.content, content_type: payload.contentType } };
    if (payload.nextToken) {
      body.python_cell.next_cell_token = payload.nextToken;
    }
    return this.http.post<NotebookCellResource>(
      `/api/${accountToken}/reports/${reportToken}/notebooks/${notebookToken}/cells`,
      body,
      { params: queryParams }
    );
  }

  updateCell(cellForm: ICellForm): Observable<NotebookCellResource> {
    const { accountToken, reportToken, notebookToken, cellToken, payload } = cellForm;
    const body = {
      python_cell: {
        content: payload.content,
        content_type: payload?.contentType,
        next_cell_token: payload.nextToken,
        frozen_in_layout: payload.frozen_in_layout,
      },
    };
    const queryParams = new HttpParams().set('embed[new_python_cell_run]', '1');
    return this.http.patch<NotebookCellResource>(
      `/api/${accountToken}/reports/${reportToken}/notebooks/${notebookToken}/cells/${cellToken}`,
      body,
      { params: queryParams }
    );
  }

  public destroyCell(accountToken: string, reportToken: string, notebookToken: string, celltoken: string) {
    return this.http.delete<void>(
      `/api/${accountToken}/reports/${reportToken}/notebooks/${notebookToken}/cell/${celltoken}`
    );
  }

  public addCellToLayout(
    accountToken: string,
    reportToken: string,
    cellToken: string
  ): Observable<NotebookVisualizationResource> {
    const body = {
      report_layout_python_cell: {
        python_cell: {
          token: cellToken,
        },
      },
    };

    return this.http.post<NotebookVisualizationResource>(
      `/api/${accountToken}/reports/${reportToken}/layout_cells`,
      body
    );
  }

  public removeCellFromLayout(accountToken: string, reportToken: string, vizToken: string): Observable<void> {
    return this.http.delete<void>(`/api/${accountToken}/reports/${reportToken}/layout_cells/${vizToken}`);
  }
}
